import MuiSnackbarContent, { type SnackbarContentProps } from "@mui/material/SnackbarContent";

export type { SnackbarContentProps };

export function SnackbarContent(props: SnackbarContentProps) {
  return <MuiSnackbarContent {...props} />;
}
